import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';

import emblaCss from '@/assets/embla.css?url';

import Hero from '@/components/partials/hero';
import WhatWeProvide from '@/components/partials/what-we-provide';
import OurServices from '@/components/partials/our-services';
import MobileApp from '@/components/partials/mobile-app';
import Marquee from '@/components/partials/marquee';
import Benefits from '@/components/partials/benefits';
import Contacts from '@/components/partials/contacts';

export const Route = createFileRoute('/')({
	component: MainPage,
	head: () => ({
		links: [
			{
				rel: 'stylesheet',
				href: emblaCss,
			},
		],
	}),
});

function MainPage() {
	return (
		<Fragment>
			<Hero />
			<WhatWeProvide />
			<OurServices />

			<div className="w-full">
				<MobileApp />
				<Marquee />
			</div>

			<Benefits />
			<Contacts />
		</Fragment>
	);
}
